var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.78996 6C7.78996 6.99 6.98996 7.79 5.99996 7.79C5.00996 7.79 4.20996 6.99 4.20996 6C4.20996 5.01 5.00996 4.21 5.99996 4.21C6.98996 4.21 7.78996 5.01 7.78996 6Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99992 10.135C7.76492 10.135 9.40992 9.095 10.5549 7.295C11.0049 6.59 11.0049 5.405 10.5549 4.7C9.40992 2.9 7.76492 1.86 5.99992 1.86C4.23492 1.86 2.58992 2.9 1.44492 4.7C0.994922 5.405 0.994922 6.59 1.44492 7.295C2.58992 9.095 4.23492 10.135 5.99992 10.135Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.9f20015ef0e4ff4d7190b4b78318eba7.svg";
export { ForwardRef as ReactComponent };